/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Tolerance_SecondsInputs */

const en_start_tolerance_seconds = /** @type {(inputs: Start_Tolerance_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Tolerance (Seconds)`)
};

const fr_start_tolerance_seconds = /** @type {(inputs: Start_Tolerance_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolérance de début (secondes)`)
};

const de_start_tolerance_seconds = /** @type {(inputs: Start_Tolerance_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starttoleranz (Sekunden)`)
};

const it_start_tolerance_seconds = /** @type {(inputs: Start_Tolerance_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolleranza di avvio (secondi)`)
};

const ru_start_tolerance_seconds = /** @type {(inputs: Start_Tolerance_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Допуск начала (в секундах)`)
};

const es_start_tolerance_seconds = /** @type {(inputs: Start_Tolerance_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolerancia de inicio (segundos)`)
};

const zh_cn2_start_tolerance_seconds = /** @type {(inputs: Start_Tolerance_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启动容差（秒）`)
};

const ja_start_tolerance_seconds = /** @type {(inputs: Start_Tolerance_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始許容値（秒）`)
};

const hi_start_tolerance_seconds = /** @type {(inputs: Start_Tolerance_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रारंभ सहनशीलता (सेकंड)`)
};

const pt_pt2_start_tolerance_seconds = /** @type {(inputs: Start_Tolerance_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolerância de inicialização (segundos)`)
};

/**
* | output |
* | --- |
* | "Start Tolerance (Seconds)" |
*
* @param {Start_Tolerance_SecondsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const start_tolerance_seconds = /** @type {((inputs?: Start_Tolerance_SecondsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Tolerance_SecondsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_start_tolerance_seconds(inputs)
	if (locale === "de") return de_start_tolerance_seconds(inputs)
	if (locale === "it") return it_start_tolerance_seconds(inputs)
	if (locale === "ru") return ru_start_tolerance_seconds(inputs)
	if (locale === "es") return es_start_tolerance_seconds(inputs)
	if (locale === "zh-CN") return zh_cn2_start_tolerance_seconds(inputs)
	if (locale === "ja") return ja_start_tolerance_seconds(inputs)
	if (locale === "hi") return hi_start_tolerance_seconds(inputs)
	if (locale === "pt-PT") return pt_pt2_start_tolerance_seconds(inputs)
	return en_start_tolerance_seconds(inputs)
});